const removeScrollLockClasses = () => {
  const body = document.getElementsByTagName("body")[0];

  body.removeAttribute("class");
  body.removeAttribute("style");
};

export default removeScrollLockClasses;
